// @flow
import React from 'react'
import Spinner from 'react-spinkit'

import styles from './Loading.module.scss'

type Props = {
  spin?: string,
  hideTitle?: boolean,
  color?: string
};
const Loading = (props: Props) => {
  return (
    <div className={styles.container}>
      <Spinner name={props.spin ? props.spin : 'ball-scale-multiple'} color={props.color || 'white'} fadeIn='none' />
      {props.hideTitle ? null : <p>Loading...</p>}
    </div>
  )
}

export default Loading
